import styled from "@emotion/styled";
import { Link } from "react-router";

export const TableSettingsLink = styled(Link)`
  &:hover {
    color: var(--mb-color-brand);
  }
`;
